import linkifyHtml from "linkify-html";

let debounceTimer = null;

// メッセージが読み込まれたときのイベントリスナー
document.addEventListener("message-load", () => {
  const linkifyMessages = () => {
    // リンク化されていないメッセージノードを取得
    const linkifiableNodes = document.querySelectorAll(".js-linkifiable-message-body:not([data-linkified])");
    const linkifyOptions = {
      // 生成されたリンクに特定のクラスを付与する。見た目など調整のため。
      className: "link-default",
      // リンクは新しいタブ/ウィンドウで開かせる。
      target: "_blank",
    };

    for (const node of linkifiableNodes) {
      // linkifyHtml 呼び出し
      node.innerHTML = linkifyHtml(node.innerHTML, linkifyOptions);
      // 一度リンク化したら次回以降の処理から除外する。
      node.dataset.linkified = "";
    }
  };

  // デバウンス処理。一定時間内に複数回呼ばれた場合、最後の1回だけ実行する。
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(linkifyMessages, 100);
});
